module.exports = __webpack_public_path__ + "static/pivvot_logo_animation-7c4c0e04eb7fb1689fa71b2a350502d8.mp4";